import { css, html } from "lit";
import { BaseComponent } from "../../BaseComponent.js";
import { defineElement } from "../../../decorators/defineElement.js";
import { prop } from "../../../decorators/prop/index.js";
import { updateCSSVariables } from "./utils.js";
import { mediaQueries } from "../../../responsive/index.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
const DEFAULT_GRID_COLUMN_COUNT = "24";
let DsfGrid = class extends BaseComponent {
  constructor() {
    super(...arguments);
    this.dsf_cols = DEFAULT_GRID_COLUMN_COUNT;
  }
  render() {
    updateCSSVariables(this);
    return html`<slot></slot>`;
  }
};
DsfGrid.shadowRootOptions = {
  ...BaseComponent.shadowRootOptions,
  delegatesFocus: false
};
DsfGrid.styles = [
  ...BaseComponent.styles,
  css`
      :host {
        display: grid;
        grid-template-columns: repeat(var(--dsf-grid-cols), minmax(0, 1fr));
        grid-auto-rows: max-content;
        column-gap: var(--dsf-grid-col-gap, var(--dsf-spacing-m));
        row-gap: var(--dsf-grid-row-gap, var(--dsf-spacing-m));
        margin: 0 var(--dsf-spacing-m);
      }
    `,
  mediaQueries.tablet.up(css`
      :host {
        column-gap: var(--dsf-grid-col-gap, var(--dsf-spacing-l));
        row-gap: var(--dsf-grid-row-gap, var(--dsf-spacing-l));
        margin: 0 var(--dsf-spacing-l);
      }
    `),
  mediaQueries.desktop.up(css`
      :host {
        column-gap: var(--dsf-grid-col-gap, var(--dsf-spacing-xl));
        row-gap: var(--dsf-grid-row-gap, var(--dsf-spacing-xl));
        margin: 0 var(--dsf-spacing-xl);
      }
    `)
];
__decorateClass([
  prop({ type: String, reflect: true })
], DsfGrid.prototype, "dsf_gap", 2);
__decorateClass([
  prop({ type: String, reflect: true })
], DsfGrid.prototype, "dsf_col_gap", 2);
__decorateClass([
  prop({ type: String, reflect: true })
], DsfGrid.prototype, "dsf_row_gap", 2);
__decorateClass([
  prop({ type: String })
], DsfGrid.prototype, "dsf_cols", 2);
DsfGrid = __decorateClass([
  defineElement("dsf-grid")
], DsfGrid);
export {
  DEFAULT_GRID_COLUMN_COUNT,
  DsfGrid
};
